// The single producer of consultation links and the single extractor of room ids.
//
// Four call sites used to generate a link three different ways from two different origin sources;
// only the shape below — `VITE_FRONTEND_BASE_URL` + a v4 UUID — is proven to connect in production.
// `window.location.origin` is never used: the platform routes clinics by browser `Origin` (root
// CLAUDE.md §15), so a booking made from any other host would bake that host into the patient's link.

import { v4 as uuidv4 } from "uuid";

import { ENV } from "../../config/runtimeEnv";

// Mirrors healthcare's ConsultationLinkResolver::SEGMENT_PATTERN — the backend is the contract.
const SEGMENT_PATTERN = /^[A-Za-z0-9._-]{8,128}$/;

export function generateRoomId(): string {
	return uuidv4();
}

export function generateConsultationLink(): string {
	return `${ENV.VITE_FRONTEND_BASE_URL}/patient/consultation/${generateRoomId()}`;
}

// The last path segment of a full URL or a bare room id, or null if it is not a plausible room id.
// A bare id is accepted because that is all the patient browser puts on the socket handshake.
export function extractRoomId(link: string | null | undefined): string | null {
	if (typeof link !== "string" || link === "") return null;

	const path = link.split(/[?#]/)[0].replace(/\/+$/, "");
	const segment = path.slice(path.lastIndexOf("/") + 1);

	return SEGMENT_PATTERN.test(segment) ? segment : null;
}
